import React from 'react';
import styles from './Home.module.css';
import WhoWeAreCover from '../Components/WhoWeAre';
import AboutUs from '../Components/AboutUs';
import AboutUs2 from '../Components/AboutUs2';
import Social from '../Components/Social';
import Social2 from '../Components/Social2';
import Private from '../Components/Private';
import Private2 from '../Components/Private2';
import Safe from '../Components/Safe';
import Safe2 from '../Components/Safe2';
import Safe3 from '../Components/Safe3';
import Intuitive from '../Components/Intuitive';
import Intuitive2 from '../Components/Intuitive2';
import Authentic from '../Components/Authentic';
import Footer from '../../Desktop/Components/Footer';
import WhoWeAre2 from '../Components/WhoWeAre2';

const WhoWeAre = ({onNavigate}) => {
  return (
    <main className={styles.home}> 
      {/* <WhoWeAreCover /> */}
      <WhoWeAre2/>
      <AboutUs2 />
      <Social />
      <Social2 />
      <Private />
      <Private2 />
      <Safe />
      <Safe2 />
      <Safe3 />
      <Intuitive />
      <Intuitive2 />
      <Authentic />
      <Footer  onNavigate={onNavigate}/>
    </main>
  );
};

export default WhoWeAre;
